import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppCodeModule } from './layouts/main-layout/app.code.component';
import { AppComponent } from './app.component';
import { AppMainComponent } from './layouts/main-layout/app.main.component';
import { AppConfigComponent } from './layouts/main-layout/app.config.component';
import { AppMenuComponent } from './layouts/main-layout/app.menu.component';
import { AppMenuitemComponent } from './layouts/main-layout/app.menuitem.component';
import { AppInlineMenuComponent } from './layouts/main-layout/app.inlinemenu.component';
import { AppTopBarComponent } from './layouts/main-layout/app.topbar.component';
import { AppFooterComponent } from './layouts/main-layout/app.footer.component';
import { AppNotfoundComponent } from './pages/app.notfound.component';
import { AppErrorComponent } from './pages/app.error.component';
import { AppAccessdeniedComponent } from './pages/app.accessdenied.component';
import { AppLoginComponent } from './pages/app.login.component';
import { MenuService } from './layouts/main-layout/app.menu.service';
import { ClickOutsideModule } from 'ng-click-outside';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { OAuthModule } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';
import {
  VnPostSharedModule,
  MultiTranslateHttpLoader,
  SendAccessTokenInterceptor,
} from 'vnpost-shared';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppRoutes } from './app-routing.module';
import { AuthGuardService } from './services/auth-guard.service';
import { LoginLayoutComponent } from './layouts/login-layout/login-layout.component';
import { DragDropModule } from 'primeng/dragdrop';
import { CommonModule, DatePipe } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { QuicklinkModule } from 'ngx-quicklink';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { TreeSelectModule } from 'primeng/treeselect';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { SaleRecordComponent } from './llb/sale-record/sale-record.component';
import { SaleRecordAddComponent } from './llb/sale-record/sale-record-add/sale-record-add.component';
import { SaleRecordEditComponent } from './llb/sale-record/sale-record-edit/sale-record-edit.component';
import { WeightConfigurationComponent } from './llb/weight-configuration/weight-configuration.component';
import { WeightConfigurationAddComponent } from './llb/weight-configuration/weight-configuration-add/weight-configuration-add.component';
import { WeightConfigurationEditComponent } from './llb/weight-configuration/weight-configuration-edit/weight-configuration-edit.component';
import { CategoryComponent } from './llb/category/category.component';
import { ProductComponent } from './llb/product/product.component';
import { CreateCategoryComponent } from './llb/category/create-category/create-category.component';
import { EditCategoryComponent } from './llb/category/edit-category/edit-category.component';
import { CreateProductComponent } from './llb/product/create-product/create-product.component';
import { EditProductComponent } from './llb/product/edit-product/edit-product.component';
import { ImportCategoryComponent } from './llb/category/import-category/import-category.component';
import { ImportProductComponent } from './llb/product/import-product/import-product.component';
import { ReportByDateComponent } from './llb/report-by-date/report-by-date.component';
import { ReportUnitProductComponent } from './llb/report-unit-product/report-unit-product.component';
import { ReportDetailComponent } from './llb/report-detail/report-detail.component';
import { ImportSaleRecordComponent } from './llb/sale-record/import-sale-record/import-sale-record.component';
import { LlbListComponent } from './llb/users/index/index.component';
import { LlbAddComponent } from './llb/users/add/add.component';
import { LlbEditComponent } from './llb/users/edit/edit.component';
import { LlbInfomationComponent } from './llb/users/infomation/infomation.component';
import { LlbImportComponent } from './llb/users/import/import.component';
import { LlbResetpasswdComponent } from './llb/users/resetpasswd/resetpasswd.component';
import { AddCalculateUnitComponent } from './llb/calculate-unit/add-calculate-unit/add-calculate-unit.component';
import { CalculateUnitComponent } from './llb/calculate-unit/calculate-unit.component';
import { EditCalculateUntComponent } from './llb/calculate-unit/edit-calculate-unit/edit-calculate-unit.component';
import { TypeCustomerComponent } from './llb/type-customer/type-customer.component';
import { EditTypeCustomerComponent } from './llb/type-customer/edit-type-customer/edit-type-customer.component';
import { CreateTypeCustomerComponent } from './llb/type-customer/create-type-customer/create-type-customer.component';
import { CommissionsForSaleComponent } from './llb/commissions-for-sale/commissions-for-sale.component';
import { CreateCommissionsForSaleComponent } from './llb/commissions-for-sale/create-commissions-for-sale/create-commissions-for-sale.component';
import { EditCommissionsForSaleComponent } from './llb/commissions-for-sale/edit-commissions-for-sale/edit-commissions-for-sale.component';
import { GroupServiceProductComponent } from './llb/group-service-product/group-service-product.component';
import { CreateGroupServiceProductComponent } from './llb/group-service-product/create-group-service-product/create-group-service-product.component';
import { EditGroupServiceProductComponent } from './llb/group-service-product/edit-group-service-product/edit-group-service-product.component';
import { CommissionQualityComponent } from './llb/commission-quality/commission-quality.component';
import { EditCommissionQualityComponent } from './llb/commission-quality/edit-commission-quality/edit-commission-quality.component';
import { CreateCommissionQualityComponent } from './llb/commission-quality/create-commission-quality/create-commission-quality.component';
import { CommissionForStageComponent } from './llb/commission-for-stage/commission-for-stage.component';
import { CreateCommissionForStageComponent } from './llb/commission-for-stage/create-commission-for-stage/create-commission-for-stage.component';
import { EditCommissionForStageComponent } from './llb/commission-for-stage/edit-commission-for-stage/edit-commission-for-stage.component';
import { ImportGroupServiceProductComponent } from './llb/group-service-product/import-group-service-product/import-group-service-product.component';
import { ServiceProductComponent } from './llb/service-product/service-product.component';
import { AddServiceProductComponent } from './llb/service-product/add-service-product/add-service-product.component';
import { EditServiceProductComponent } from './llb/service-product/edit-service-product/edit-service-product.component';
import { ImportServiceProductComponent } from './llb/service-product/import-service-product/import-service-product.component';
import { ListTitleComponent } from './llb/list-title/list-title.component';
import { CreateListTitleComponent } from './llb/list-title/create-list-title/create-list-title.component';
import { EditListTitleComponent } from './llb/list-title/edit-list-title/edit-list-title.component';
import { CategoryUnitComponent } from './llb/category-unit/category-unit.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { CommissionsForServiceComponent } from './llb/commissions-for-service/commissions-for-service.component';
import { AddCommissionsForServiceComponent } from './llb/commissions-for-service/add-commissions-for-service/add-commissions-for-service.component';
import { EditCommissionsForServiceComponent } from './llb/commissions-for-service/edit-commissions-for-service/edit-commissions-for-service.component';
import { StaffManagerComponent } from './llb/staff-manager/staff-manager.component';
import { EditStaffManagerComponent } from './llb/staff-manager/edit-staff-manager/edit-staff-manager.component';
import { SaleAssociateComponent } from './llb/sale-associate/sale-associate.component';
import { AddSaleAssociateComponent } from './llb/sale-associate/add-sale-associate/add-sale-associate.component';
import { EditSaleAssociateComponent } from './llb/sale-associate/edit-sale-associate/edit-sale-associate.component';
import { ImportSaleAssociateComponent } from './llb/sale-associate/import-sale-associate/import-sale-associate.component';
export function createTranslateLoader(http: HttpClient) {
  return new MultiTranslateHttpLoader(http);
}

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    InputGroupModule,
    InputGroupAddonModule,
    FormsModule,
    TreeSelectModule,
    AppRoutes,
    HttpClientModule,
    BrowserAnimationsModule,
    AppCodeModule,
    VnPostSharedModule.forRoot({ environment: environment }),
    ClickOutsideModule,
    ToastModule,
    TranslateModule.forRoot({
      defaultLanguage: 'vi',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: [environment.apiDomain.gateway],
        sendAccessToken: false,
      },
    }),
    DragDropModule,
    QuicklinkModule,
    ToastModule,
    MultiSelectModule,
    InputTextareaModule,
    InputSwitchModule,
  ],
  declarations: [
    AppComponent,
    AppMainComponent,
    AppConfigComponent,
    AppMenuComponent,
    AppMenuitemComponent,
    AppInlineMenuComponent,
    AppTopBarComponent,
    AppFooterComponent,
    AppLoginComponent,
    AppNotfoundComponent,
    AppErrorComponent,
    AppAccessdeniedComponent,
    LoginLayoutComponent,
    SaleRecordComponent,
    SaleRecordAddComponent,
    SaleRecordEditComponent,
    WeightConfigurationComponent,
    WeightConfigurationAddComponent,
    WeightConfigurationEditComponent,
    CategoryComponent,
    ProductComponent,
    CreateCategoryComponent,
    EditCategoryComponent,
    CreateProductComponent,
    EditProductComponent,
    ImportCategoryComponent,
    ImportProductComponent,
    ReportByDateComponent,
    ReportUnitProductComponent,
    ReportDetailComponent,
    ImportSaleRecordComponent,
    LlbListComponent,
    LlbAddComponent,
    LlbEditComponent,
    LlbInfomationComponent,
    LlbImportComponent,
    LlbResetpasswdComponent,
    AddCalculateUnitComponent,
    CalculateUnitComponent,
    EditCalculateUntComponent,
    TypeCustomerComponent,
    EditTypeCustomerComponent,
    CreateTypeCustomerComponent,
    CommissionsForSaleComponent,
    CreateCommissionsForSaleComponent,
    EditCommissionsForSaleComponent,
    GroupServiceProductComponent,
    CreateGroupServiceProductComponent,
    EditGroupServiceProductComponent,
    CommissionQualityComponent,
    EditCommissionQualityComponent,
    CreateCommissionQualityComponent,
    CommissionForStageComponent,
    CreateCommissionForStageComponent,
    EditCommissionForStageComponent,
    ImportServiceProductComponent,
    ListTitleComponent,
    CreateListTitleComponent,
    EditListTitleComponent,
    CategoryUnitComponent,
    ImportGroupServiceProductComponent,
    ServiceProductComponent,
    AddServiceProductComponent,
    EditServiceProductComponent,
    ImportServiceProductComponent,
    StaffManagerComponent,
    EditStaffManagerComponent,
    CommissionsForServiceComponent,
    AddCommissionsForServiceComponent,
    EditCommissionsForServiceComponent,
    SaleAssociateComponent,
    AddSaleAssociateComponent,
    EditSaleAssociateComponent,
    ImportSaleAssociateComponent
  ],
  providers: [
    MenuService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SendAccessTokenInterceptor,
      multi: true,
    },
    MessageService,
    ConfirmationService,
    AuthGuardService,
    DatePipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
